import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-planet-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg text-foreground-900">星球漫画</span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              星球漫画提供免费漫画全集在线免费阅读，下拉式阅读体验，海量免费漫画网站大全，免VIP看全集。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm text-foreground-900 mb-4">漫画分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-500 hover:text-primary-600 transition-colors duration-200">
                    {cat.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm text-foreground-900 mb-4">更多分类</h4>
            <ul className="space-y-2">
              {categories.slice(4).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-500 hover:text-primary-600 transition-colors duration-200">
                    {cat.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm text-foreground-900 mb-4">关于我们</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors duration-200">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about#reputation" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors duration-200">
                  用户口碑
                </Link>
              </li>
              <li>
                <Link to="/about#contact" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors duration-200">
                  联系我们
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {currentYear} 星球漫画 - 免费漫画全集在线免费阅读。本站所有漫画均来自互联网，仅供学习交流使用。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-600 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-600 transition-colors" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-600 transition-colors" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}